<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
    <b-form v-if="dossierSelected" @submit.prevent="handleSubmit(send())">
      <div class="block-flat" v-if="request && request.type == 1">
        <d14023-nature-travaux></d14023-nature-travaux>
      </div>
      <div class="block-flat" v-if="request && request.type == 2">
        <dde-alignement></dde-alignement>
      </div>
      <div class="block-flat" v-if="request && request.type == 3">
        <d14023-nature-travaux-amenagement></d14023-nature-travaux-amenagement>
      </div>
      <div class="stepper-control">
        <b-button
          variant="white"
          @click="previous"
          class="btn marginRight-10 marginBottom-15"
        >
          <font-awesome-icon
            icon="caret-left"
            class="marginRight-5"
          ></font-awesome-icon>
          Précédent
        </b-button>
        <b-button type="submit" variant="warning" class="marginBottom-15">
          <span>Suivant</span>
          <font-awesome-icon
            icon="caret-right"
            class="marginLeft-5"
          ></font-awesome-icon>
        </b-button>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vuex from "vuex";
import Vue from "vue";
import D14023NatureTravaux from "./D14023/NatureTravaux.vue";
import D14023AmenagementNatureTravaux from "./D14023_Amenagement/NatureTravaux.vue";
import DemandeAlignement from "./Alignement/DemandeAlignement.vue";

export default {
  props: ["value", "demandeurInfo"],
  name: "ChoixCerfa",
  components: {
    "d14023-nature-travaux": D14023NatureTravaux,
    "dde-alignement": DemandeAlignement,
    "d14023-nature-travaux-amenagement": D14023AmenagementNatureTravaux,
  },
  data: () => ({
    natureWorkOther: null,
    selectedChoices: [],
    naturesTvx: [
      {
        text: "Création/Suppression d’infrastructures souterraines",
        value: "Création/Suppression d’infrastructures souterraines",
      },
      {
        text: "Création/Suppression d’infrastructures aériennes ",
        value: "Création/Suppression d’infrastructures aériennes ",
      },
      {
        text: "Pose/Dépose d’armoire ou Shelter",
        value: "Pose/Dépose d’armoire ou Shelter",
      },
      {
        text: "Réparation d’infrastructures existantes",
        value: "Réparation d’infrastructures existantes",
      },
      { text: "Travaux de câblage", value: "Travaux de câblage" },
    ],
  }),
  mounted() {
    this.$nextTick(function() {});
  },
  methods: {
    ...Vuex.mapActions("Cerfa", [
      "addCerfa14023",
      "initCerfa14023",
      "setAlignement",
      "setCerfa14023",
      "updateCerfa14023",
    ]),
    ...Vuex.mapActions("Dossiers", ["setDossier"]),
    previous() {
      this.$emit("previous");
    },
    choiceCerfa(cerfa) {
      const index = this.selectedChoices.indexOf(cerfa);
      if (index === -1) {
        // Ajouter le choix s'il n'est pas déjà sélectionné
        this.selectedChoices.push(cerfa);
      } else {
        this.selectedChoices.splice(index, 1);
      }
    },
    choiceSelected(cerfa) {
      return this.selectedChoices.includes(cerfa);
    },
    send() {
      this.$refs.formObserver.validate().then((success) => {
        if (success == true) {
          if (
            this.request.type == 1 ||
            this.request.type == 2 ||
            this.request.type == 3
          ) {
            this.$emit("submit");
          } else {
            this.$emit("error", "Veuillez Choisir un cerfa");
          }
        } else {
          this.$emit("error", "Veuillez corriger les erreurs du formulaire");
        }
      });
    },
  },
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfa14023"]),
    ...Vuex.mapGetters("Cerfa", ["alignement"]),
    ...Vuex.mapGetters("Dossiers", ["dossierSelected"]),
    request: {
      get: function() {
        return this.dossierSelected;
      },
      set: function(newValue) {
        this.setDossier(newValue);
      },
    },
    alignement: {
      get: function() {
        return this.alignement;
      },
      set: function(newValue) {
        this.setAlignement(newValue);
      },
    },
    cerfa1402301: {
      get: function() {
        return this.cerfa14023;
      },
      set: function(newValue) {
        this.setCerfa14023(newValue);
      },
    },
  },
};
</script>
